import { useState, useContext } from 'react';

import { ModalContext, AppContext } from 'commons-ui';

const useContent = (handleFilterSubmit: any) => {
	const [showLoader, setShowLoader] = useState(false);
	const { setModalConfig } = useContext(ModalContext);
	const { showAlert } = useContext(AppContext);

	const handleFormSubmit = async (submittedData: any) => {
		try {
			handleFilterSubmit({ fromToDate: submittedData?.dateRange, transactionTypes: submittedData?.transactionTypes });
			setShowLoader(true);
			setShowLoader(false);
		} catch (error) {
			showAlert('Error in Fetching Transaction Pdf', { type: 'error' });
		} finally {
			setModalConfig({ isOpen: false });
		}
	};

	const handleFormCancel = () => {
		setModalConfig({ isOpen: false });
	};

	return {
		showLoader,
		setShowLoader,
		handleFormCancel,
		handleFormSubmit
	};
};

export default useContent;
